import { useState, useEffect } from 'react';
import { useAppState } from '../app-context/src/';

const SetHostLocale = () => {
  const [hasSetHostLocale, setHostLocale] = useState(false);
  const appState = useAppState();

  useEffect(() => {
    if (!hasSetHostLocale) {
      appState.changeToHostLocale();
      setHostLocale(true);
    }
  }, [hasSetHostLocale, appState]);

  return null;
};

export default SetHostLocale;
